import { Koi } from '@ksyos/koi';

export enum Choice {
    all = 'all',
    specific = 'specific',
}

export enum ChoiceWithEpisodeCategory {
    all = 'all',
    episodeCategory = 'episodeCategory',
    specific = 'specific',
}

export enum ChoiceAllowNone {
    all = 'all',
    none = 'none',
    specific = 'specific',
}

export enum FilterChoice {
    compositePatientInvoice = 'compositePatientInvoice',
    group = 'group',
    groupAndOrganization = 'groupAndOrganization',
    organization = 'organization',
    singularPatientInvoice = 'singularPatientInvoice',
}

export type ServiceChoice = Choice;
export type ServiceChoiceWithEpisodeCategory = ChoiceWithEpisodeCategory;
export type GroupChoice = Choice;
export type OrganizationChoice = Choice;
export type HealthInsurerChoice = Choice;
export type ProfessionChoice = Choice;

export const filterChoiceSchema = Koi.koi().enum(FilterChoice);
export const serviceChoiceSchema = Koi.koi().enum(Choice);
export const serviceChoiceWithEpisodeCategorySchema = Koi.koi().enum(ChoiceWithEpisodeCategory);
export const groupChoiceSchema = Koi.koi().enum(Choice);
export const organizationChoiceSchema = Koi.koi().enum(Choice);
export const healthInsurerChoiceSchema = Koi.koi().enum(Choice);
export const professionChoiceChoiceSchema = Koi.koi().enum(Choice);
export const choiceAllowNoneSchema = Koi.koi().enum(ChoiceAllowNone);
